import { HALF_SUBS, MAIN_TYPES, SERVICE } from "@/lib/util";

const mainOf = (v) => (HALF_SUBS.includes(v) ? "half" : v);

export function VehicleTypeSelect({ value, onChange, testid = "veh-type", small }) {
  const cls = `field ${small ? "field-sm" : ""}`;
  const main = mainOf(value);
  return (
    <div className="flex gap-2">
      <select data-testid={testid} className={cls} value={main}
        onChange={(e) => onChange(e.target.value === "half" ? HALF_SUBS[0] : e.target.value)}>
        {MAIN_TYPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      {main === "half" && (
        <select data-testid={`${testid}-sub`} className={cls} value={value} onChange={(e) => onChange(e.target.value)}>
          {HALF_SUBS.map((k) => <option key={k} value={k}>{SERVICE[k].split(" — ")[1]}</option>)}
        </select>
      )}
    </div>
  );
}

export function WorkTypes({ value, onChange }) {
  const halves = value.filter((v) => HALF_SUBS.includes(v));
  const toggle = (k) => {
    const on = k === "half" ? halves.length > 0 : value.includes(k);
    if (on) return onChange(value.filter((v) => (k === "half" ? !HALF_SUBS.includes(v) : v !== k)));
    onChange([...value, k === "half" ? HALF_SUBS[0] : k]);
  };
  const setHalf = (sub) => onChange([...value.filter((v) => !HALF_SUBS.includes(v)), ...(sub === "both" ? HALF_SUBS : [sub])]);
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {MAIN_TYPES.map(([k, l]) => {
          const on = k === "half" ? halves.length > 0 : value.includes(k);
          return <button type="button" key={k} data-testid={`work-type-${k}`} onClick={() => toggle(k)}
            className={`h-12 rounded-xl border-2 font-bold ${on ? "border-blue-700 bg-blue-50 text-blue-800" : "border-slate-200"}`}>{l}</button>;
        })}
      </div>
      {halves.length > 0 && (
        <select data-testid="work-type-half-sub" className="field field-sm" value={halves.length > 1 ? "both" : halves[0]} onChange={(e) => setHalf(e.target.value)}>
          <option value="flatbed">نصف شاحنة: سطحة</option>
          <option value="lorry">نصف شاحنة: هاف لوري</option>
          <option value="both">نصف شاحنة: سطحة وهاف لوري</option>
        </select>
      )}
    </div>
  );
}

export const TypeOptions = () => Object.entries(SERVICE).filter(([k]) => k !== "tow").map(([k, l]) => <option key={k} value={k}>{l}</option>);
